export const PRERENDER_DEPS = {
  SEO: 'SeoComponents',
  FOOTER: 'Footer',
} as const;
